import {localize} from '@/utils/i18n'

const genderSelectOptions = [
    {
        'id': localize({
            ru: 'Мужской',
            en: 'Male',
            cn: 'Male'
        }),
        'selected': true,
        'disabled': false,
        'text': localize({
            ru: 'Мужской',
            en: 'Male',
            cn: 'Male'
        }),

    },
    {
        'id': localize({
            ru: 'Женский',
            en: 'Female',
            cn: 'Female'
        }),
        'selected': false,
        'disabled': false,
        'text': localize({
            ru: 'Женский',
            en: 'Female',
            cn: 'Female'
        }),
    },
]

const reasonChoose = [
    {
        'id' : localize ({
            ru: 'Стабильная компания, надежный работодатель',
            en: '',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Стабильная компания, надежный работодатель',
            en: '',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Понятный карьерный рост и участие в интересных проектах',
            en: '',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Понятный карьерный рост и участие в интересных проектах',
            en: '',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Привлекательная заработная плата',
            en: '',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Привлекательная заработная плата',
            en: '',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Социальный пакет',
            en: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Социальный пакет',
            en: '',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Компетентный руководитель',
            en: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Компетентный руководитель',
            en: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Конкурентная заработная плата',
            en: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Конкурентная заработная плата',
            en: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Удобный график работы',
            en: '',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Удобный график работы',
            en: '',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Профессиональная команда, хороший коллектив',
            en: '',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Профессиональная команда, хороший коллектив',
            en: '',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Комфортные условия труда',
            en: '',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Комфортные условия труда',
            en: '',
            cn: ''
        })
    }
]

const howKnow = [
    {
        'id' : localize ({
            ru: 'На сайте ИНК (irkutskoil.ru)',
            en: 'Site IOC (irkutskoil.ru)',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'На сайте ИНК (irkutskoil.ru)',
            en: 'Site IOC (irkutskoil.ru)',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'На сайтах поиска работы hh.ru, superjob.ru и др.',
            en: 'Job Search Sites hh.ru, superjob.ru and each',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'На сайтах поиска работы hh.ru, superjob.ru и др.',
            en: 'Job Search Sites hh.ru, superjob.ru and each',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Ранее работал в ИНК, дочерних и подрядных компаниях',
            en: 'Previously worked at IOC, subsidiary and contracting',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Ранее работал в ИНК, дочерних и подрядных компаниях',
            en: 'Previously worked at IOC, subsidiary and contracting',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'По рекомендации друзей и сотрудников ИНК',
            en: 'The recommendation of friends and IOC employees',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'По рекомендации друзей и сотрудников ИНК',
            en: 'The recommendation of friends and IOC employees',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Из интернет-рекламы и соцсетей',
            en: 'From the Internet and social networks',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Из интернет-рекламы и соцсетей',
            en: 'From the Internet and social networks',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'Из наружной рекламы, ТВ и радио',
            en: 'From outdoor advertising, TV and radio',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'Из наружной рекламы, ТВ и радио',
            en: 'From outdoor advertising, TV and radio',
            cn: ''
        })
    },
    {
        'id' : localize ({
            ru: 'На ярмарке вакансий, в центре занятости',
            en: 'At a job fair, at the employment center',
            cn: ''
        }),
        'selected' : false,
        'disabled' : false,
        'text' : localize({
            ru: 'На ярмарке вакансий, в центре занятости',
            en: 'At a job fair, at the employment center',
            cn: ''
        })
    },
]

const formTextLocalize = {
    hotFillForm: localize({
        ru: 'Отправить информацию',
        en: 'Send information',
        cn: 'Send information'
    }),
    title: localize({
        ru: 'Контактная информация',
        en: 'Contact Information',
        cn: 'Contact Information'
    }),
    text: localize({
        ru: 'Хотите стать частью нашей команды? — Заполните информацию о себе, чтобы мы могли предложить Вам подходящую вакансию.',
        en: 'Do you want to become part of our team? — Fill out information about yourself so that we can offer you a suitable vacancy.',
        cn: 'Do you want to become part of our team? — Fill out information about yourself so that we can offer you a suitable vacancy.'
    }),
    surname: localize({
        ru: 'Фамилия',
        en: 'Lastname',
        cn: 'Lastname'
    }),
    firstname: localize({
        ru: 'Имя',
        en: 'Firstname',
        cn: 'Firstname'
    }),
    patronymic: localize({
        ru: 'Отчество',
        en: 'Patronymic',
        cn: 'Patronymic'
    }),
    phoneNumber: localize({
        ru: 'Контактный телефон',
        en: 'Phone number',
        cn: 'Phone number'
    }),
    email: localize({
        ru: 'Email',
        en: 'Email',
        cn: 'Email'
    }),
    vacancy: localize({
        ru: 'Вакансия',
        en: 'Vacancy',
        cn: 'Vacancy'
    }),
    personalInfo: localize({
        ru: 'Личная информация',
        en: 'Personal info',
        cn: 'Personal info'
    }),
    gender: localize({
        ru: 'Пол',
        en: 'gender',
        cn: 'gender'
    }),
    city: localize({
        ru: 'Город/район проживания',
        en: 'City',
        cn: 'City'
    }),
    bDay: localize({
        ru: 'Дата рождения',
        en: 'Date of Birth',
        cn: 'Date of Birth'
    }),
    nationality: localize({
        ru: 'Гражданство',
        en: 'Citizenship',
        cn: 'Citizenship'
    }),
    experience: localize({
        ru: 'Опыт работы',
        en: 'Experience',
        cn: 'Experience'
    }),
    workPeriod: localize({
        ru: 'Период работы',
        en: 'Work period',
        cn: 'Work period'
    }),
    company: localize({
        ru: 'Название компании',
        en: 'Company name',
        cn: 'Company name'
    }),
    position: localize({
        ru: 'Должность',
        en: 'Position',
        cn: 'Position'
    }),
    jobResponsibilities: localize({
        ru: 'Должностные обязанности',
        en: 'Job responsibilities',
        cn: 'Job responsibilities'
    }),
    education: localize({
        ru: 'Образование',
        en: 'Education',
        cn: 'Education'
    }),
    educationPeriod: localize({
        ru: 'Период обучения',
        en: 'Education period',
        cn: 'Education period'
    }),
    educationalInstitution: localize({
        ru: 'Учебное заведение',
        en: 'Educational institution',
        cn: 'Educational institution'
    }),
    speciality: localize({
        ru: 'Факультет, специализация',
        en: 'Faculty, specialization',
        cn: 'Faculty, specialization'
    }),
    fillForm: localize({
        ru: 'Заполнить анкету',
        en: 'Fill out the form',
        cn: 'Fill out the form'
    }),
    attachCV: localize({
        ru: 'Прикрепить резюме',
        en: 'Attach CV',
        cn: 'Attach CV'
    }),
    start: localize({
        ru: 'Начало работы',
        en: 'Start',
        cn: 'Start'
    }),
    end: localize({
        ru: 'Окончание работы',
        en: 'End',
        cn: 'End'
    }),
    achievements: localize({
        ru: 'Обязанности, достижения',
        en: 'Responsibilities, achievements',
        cn: 'Responsibilities, achievements'
    }),
    addMore: localize({
        ru: 'Добавить место работы',
        en: 'Add place',
        cn: 'Add place'
    }),
    addMoreInstitution: localize({
        ru: 'Добавить место учебы',
        en: 'Add place',
        cn: 'Add place'
    }),
    delete: localize({
        ru: 'Удалить',
        en: 'Delete',
        cn: 'Delete'
    }),
    graduationYear: localize({
        ru: 'Год окончания',
        en: 'Graduation year',
        cn: 'Graduation year'
    }),
    additionalQualifications: localize({
        ru: 'Дополнительная квалификация',
        en: 'Additional qualifications',
        cn: 'Additional qualifications'
    }),
    additional: localize({
        ru: 'Дополнительная информация',
        en: 'Additional Information',
        cn: 'Additional Information'
    }),
    skills: localize({
        ru: 'Профессиональные знания и навыки',
        en: 'Skills',
        cn: 'Skills'
    }),
    howKnow: localize({
        ru: 'Откуда вы узнали о вакансии?',
        en: 'How did you hear about the vacancy?',
        cn: 'How did you hear about the vacancy?'
    }),
    resume: localize({
        ru: 'Прикрепить резюме',
        en: 'Attach your resume',
        cn: 'Attach your resume'
    }),
    submit: localize({
        ru: 'Отправить',
        en: 'Submit',
        cn: 'Submit'
    }),
    agreement: localize({
        ru: 'Даю согласие на обработку предоставленных мной персональных данных в период согласования моей кандидатуры на вакансию в ООО «ИНК».',
        en: 'I agree to the processing of the personal data provided by me during the period of approval of my candidacy for a vacancy at INK LLC.',
        cn: 'I agree to the processing of the personal data provided by me during the period of approval of my candidacy for a vacancy at INK LLC.'
    }),
    agreementTwo: localize({
        ru: 'Даю согласие на хранение резюме (анкеты) в кадровом резерве для возможного последующего трудоустройства в ООО «ИНК».*',
        en: 'I agree to storing my resume (application form) in the personnel reserve for possible subsequent employment at INK LLC.*',
        cn: 'I agree to storing my resume (application form) in the personnel reserve for possible subsequent employment at INK LLC.*'
    }),
    noExperience: localize({
        ru: 'Без опыта работы',
        en: 'No work experience',
        cn: 'No work experience'
    }),
    until: localize({
        ru: 'По настоящее время',
        en: 'Until now',
        cn: 'Until now'
    }),
    reasonChoose: localize({
        ru: 'Почему вы выбрали нашу компанию?',
        en: 'Why did you choose our company?',
        cn: 'Why did you choose our company?'
    }),
    other: localize({
        ru: 'Введите свой вариант',
        en: 'Enter your choice',
        cn: 'Enter your choice'
    }),
    sendError: localize({
        ru: 'Что-то пошло не так, попробуйте позже',
        en: 'Something went wrong, please try again later',
        cn: 'Something went wrong, please try again later'
    })
};

export {genderSelectOptions, formTextLocalize, reasonChoose, howKnow}
